<template>
  <div class="containers-container" v-show="ifData">
    <h3 class="page-title title-slash container-tracking-title mb-3">
      {{ $t('invoices.tracking.title') }}
    </h3>
    <containers
      tile="container-tile"
      :slides="containerIds.length"
      v-show="!containersLoading"
    >
      <container
        :slot="i + 1"
        v-for="(containerId, i) in containerIds"
        :containerId="containerId"
        :invoiceShippingData="invoiceShippingData"
        @containersLoaded="handleContainersLoaded"
        :token="token"
        :key="i"
      >
      </container>
    </containers>
    <tracking-modal
      v-for="(container, i) in containers"
      :container="container"
      :key="i"
    />
    <loader v-show="containersLoading" :height="190" />
  </div>
</template>
<script>
import Containers from '@/components/invoices/tracking/Containers'
import Container from '@/components/invoices/tracking/Container'
import Loader from '@/components/common/Loader'
import TrackingModal from '@/components/invoices/modals/TrackingModal'

export default {
  data() {
    return {
      containersLoading: true,
      containers: []
    }
  },
  mounted() {
    this.$mpTrack('Invoice details - Container widget component rendered')
  },
  methods: {
    handleContainersLoaded(containerData) {
      this.containersLoading = false
      this.containers.push(containerData)
    }
  },
  computed: {
    ifData() {
      let count = 0
      this.containers.map((i) => {
        return i !== null ? count++ : true
      })
      return count > 0
    }
  },
  components: {
    Containers,
    Container,
    Loader,
    TrackingModal
  },
  props: ['containerIds', 'invoiceShippingData', 'token']
}
</script>
<style lang="scss">
@import '../../assets/scss/variables';
.containers-container {
  .VueCarousel {
    height: 100% !important;

    .VueCarousel-wrapper {
      height: 100% !important;

      .VueCarousel-inner {
        height: 100% !important;
      }
    }
  }

  .VueCarousel-pagination {
    position: relative;
    bottom: 0;
    text-align: left !important;

    li {
      padding-right: 5px !important;
      line-height: 0;

      button {
        width: 30px !important;
        height: 3px !important;
        border-radius: 15px;

        &:focus {
          outline: none;
        }
      }
    }
  }

  .container-tile {
    margin-bottom: 30px;
    background-size: cover;
    background-position: center;
    border-radius: $card-border-radius;
    box-shadow: $box-shadow-sm;
    position: relative;
    overflow: hidden;
    padding: 20px;

    &::before {
      content: ' ';
      height: 100%;
      width: 100%;
      display: block;
      position: absolute;
      background: white;
      top: 0;
      left: 0;
    }

    h3 {
      font-weight: 300;
      margin: 0;
    }
  }
}
</style>
